import { getLogger } from '../utils/SearchLogger';

export default class SessionStorageImpl implements IStorageImplementation {
	clear(): void {
		window.sessionStorage.clear();
	}
	// Executes the setItem
	setItem(key: string, value: Record<string, any>): void {
		try {
			// We JSON.stringify for you so that you don't have to
			window.sessionStorage.setItem(key, JSON.stringify(value));
		} catch (e) {
			getLogger().error('Session Storage Utils', 'Error writing to Session Storage', e.toString());
		}
	}

	// Executes the getItem
	getItem(key: string): Record<string, any> | null {
		let item: Record<string, any> | null = null;

		try {
			const sessionStorageItem = window.sessionStorage.getItem(key);
			// We JSON.parse it for you so that you don't have to
			item = JSON.parse(sessionStorageItem);
		} catch (e) {
			getLogger().error('Session Storage Utils', 'Error reading from Session Storage', e.toString());
		}

		return item;
	}

	// Executes the removeItem
	removeItem(key: string): void {
		window.sessionStorage.removeItem(key);
	}
}
